import EmployeeModel from "./EmployeeModel";
import LegalEntityModel from "./LegalEntityModel";
import Vehicle from "./Vehicle";
import CounterpartyType from "./enums/CounterpartyType";

export default class CounterpartyModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970, 0, 1);
			this.birthdate = data.birthdate;
			this.firstname = data.firstname ?? '';
			this.lastname = data.lastname ?? '';
			this.middlename = data.middlename;
			this.phone = data.phone ?? '';
			this.email = data.email ?? '';
			this.isMale = data.isMale;
			this.notes = data.notes;

			if (data.manager && data.manager.id) {
				this.manager = new EmployeeModel(data.manager);
			}

			if (data.vehicles && data.vehicles.length) {
				this.vehicles = data.vehicles.map((_: any) => new Vehicle(_));
			}

			if (data.legalEntity?.id) {
				this.legalEntity = new LegalEntityModel(data.legalEntity);
			}

			if (data.types?.length) {				
				this.types = data.types.flatMap((_: any) => {
					if (_?.counterpartyTypeId) {
						return _.counterpartyTypeId as CounterpartyType;
					} else {
						return [];
					}
				});
			}
		}
	}

	id = 0;
	date = new Date(1970, 0, 1);
	birthdate: Date | null = null;
	firstname: string | null = null;
	lastname: string | null = null;
	middlename: string | null = null;
	phone: string | null = null;
	email: string | null = null;
	isMale: boolean | null = null;
	legalEntity: LegalEntityModel | null = null;
	manager: EmployeeModel | null = null;
	notes: string | null = null;
	/** customer's vehicles array */
	vehicles: Array<Vehicle> | null = null;
	/** customer's types (consumer, supplier, contractor ...) */
	types: Array<CounterpartyType> | null = null;	
}
